export * from './prizmIcons-chevron-mini-right.icon';
